export default __webpack_public_path__ + "static/media/flag11.e40ea405.png";